import angular from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-preferences.component'

let module = angular.module('myPreferencesModule', [
  uiRouter
])

.filter('isEmpty', () => {
  return (aliasCard) => {
    if (aliasCard) {
      return '"' + aliasCard + '"'
    }
  }
})

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('profile.myProfile.myPreferences', {
      url: '/my-preferences',
      component: 'myPreferencesPage',
      authenticate: true
    })
})

.component('myPreferencesPage', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-preferences/index.js